
import * as Yup from "yup";
const AccountContactSchema = Yup.object().shape({
  message: Yup.string()
    .required("validator:global.required")
    .min(100, "validator:AccountContactSchema.message.min")
    .max(1000, "validator:AccountContactSchema.message.max")
});
export default AccountContactSchema;